<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-access-requests">
  <div class="org-admin-access-requests--layout">
    <app-org-admin-sidebar class="org-admin-access-requests--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-access-requests--content">
      <app-page-header></app-page-header>
      <div class="access-requests-container">
        <!-- Tabs -->
        <div class="tabs-container">
          <div class="activities__tabs-row">
            <div class="activities__tabs">
            <button 
              class="activities__tab" 
              [class.activities__tab--active]="activeTab === 'assetRequest'"
              (click)="setActiveTab('assetRequest')"
            >
              Asset Request
            </button>
            <button 
              class="activities__tab" 
              [class.activities__tab--active]="activeTab === 'publishAssets'"
              (click)="setActiveTab('publishAssets')"
            >
              Publish Assets
            </button>
            </div>
          </div>

          <!-- Tab Content -->
          <div class="tab-content-wrapper">
            <!-- Asset Request Tab -->
            <div class="tab-content" [style.display]="activeTab === 'assetRequest' ? 'block' : 'none'">
              <app-asset-request></app-asset-request>
            </div>

            <!-- Publish Assets Tab -->
            <div class="tab-content" [style.display]="activeTab === 'publishAssets' ? 'block' : 'none'">
              <app-publish-assets></app-publish-assets>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
